import React, { useState } from "react";
import { Form } from "semantic-ui-react";

const PhoneInput = (props) => {
  const [value, setValue] = useState(props.value);

  const handleFormChange = (e) => {
    let { value } = e.target;
    if (value && value.length > 0) {
      const intlCode = "+1";
      value = `${intlCode}${value.replace(/[\D]/g, "")}`;
    }
    e.target.value = value;
    props.onChange(e, e.target);
    setValue(value);
  };

  const c = (i) => {
    return value[i] || "";
  };

  const getDisplayValue = () => {
    if (value && value.length > 1) {
      return `${value.length > 2 ? "(" : ""}${c(2)}${c(3)}${c(4)}${value.length > 5 ? ") " : ""}${c(5)}${c(6)}${c(7)}${value.length > 8 ? "-" : ""}${c(8)}${c(9)}${c(10)}${c(11)}`;
    }
  };

  const inputProps = {
    ...props,
    placeholder: "(512) 555-1212",
    maxLength: 14,
    minLength: 14,
    value: getDisplayValue(),
    onChange: handleFormChange,
  };

  return <Form.Input {...inputProps} />;
};

export default PhoneInput;
